const ROOT_API = process.env.VUE_APP_ROOT_API;

const GET_ALL_FO = ROOT_API + 'address/get_all_fo.php';
const GET_ALL_REGIONS = ROOT_API + 'address/get_all_regions.php';
const GET_ALL_FORESTRIES = ROOT_API + 'address/get_all_forestries.php';
const GET_ALL_LOCALFORESTRIES = ROOT_API + 'address/get_all_localforestries.php';
const GET_ALL_SUBFORESTRIES = ROOT_API + 'address/get_all_subforestries.php';
const GET_ALL_AREAS = ROOT_API + 'address/get_all_areas.php';

export default {
  namespaced: true,

  state: {
    selectedFo: null,
    selectedRegion: null,
    selectedForestry: null,
    selectedLocalforestry: null,
    selectedSubforestry: null,
    selectedArea: null,
    selectedSection: null,

    foList: [],
    regionList: [],
    forestryList: [],
    localforestryList: [],
    subforestryList: [],
    areaList: [],

    loadingFoList: false,
    loadingRegionList: false,
    loadingForestryList: false,
    loadingLocalforestryList: false,
    loadingSubforestryList: false,
    loadingAreaList: false
  },
  mutations: {
    setSelectedFo(state, payload) {
      state['selectedFo'] = payload;
    },
    setSelectedRegion(state, payload) {
      state['selectedRegion'] = payload;
    },
    setSelectedForestry(state, payload) {
      state['selectedForestry'] = payload;
    },
    setSelectedLocalforestry(state, payload) {
      state['selectedLocalforestry'] = payload;
    },
    setSelectedSubforestry(state, payload) {
      state['selectedSubforestry'] = payload;
    },
    setSelectedArea(state, payload) {
      state['selectedArea'] = payload;
    },

    setSelectedSection(state, payload) {
      state['selectedSection'] = payload;
    },

    setFoList(state, payload) {
      state['foList'] = payload;
    },
    setRegionList(state, payload) {
      state['regionList'] = payload;
    },
    setForestryList(state, payload) {
      state['forestryList'] = payload;
    },
    setLocalforestryList(state, payload) {
      state['localforestryList'] = payload;
    },
    setSubforestryList(state, payload) {
      state['subforestryList'] = payload;
    },
    setAreaList(state, payload) {
      state['areaList'] = payload;
    },

    setListLoading(state, payload) {
      switch (payload) {
        case 'foList': state.loadingFoList = true; break;
        case 'regionList': state.loadingRegionList = true; break;
        case 'forestryList': state.loadingForestryList = true; break;
        case 'localforestryList': state.loadingLocalforestryList = true; break;
        case 'subforestryList': state.loadingSubforestryList = true; break;
        case 'areaList': state.loadingAreaList = true; break;
      }
    },
    unsetListLoading(state, payload) {
      switch (payload) {
        case 'foList': state.loadingFoList = false; break;
        case 'regionList': state.loadingRegionList = false; break;
        case 'forestryList': state.loadingForestryList = false; break;
        case 'localforestryList': state.loadingLocalforestryList = false; break;
        case 'subforestryList': state.loadingSubforestryList = false; break;
        case 'areaList': state.loadingAreaList = false; break;
      }
    },
  },
  actions: {
    selectFo(context, payload) {
      const { state, commit, dispatch } = context;

      commit('setSelectedFo', payload);

      commit('setSelectedRegion', null);
      commit('setSelectedForestry', null);
      commit('setSelectedLocalforestry', null);
      commit('setSelectedSubforestry', null);
      commit('setSelectedArea', null);
      commit('setSelectedSection', null);

      commit('setRegionList', []);
      commit('setForestryList', []);
      commit('setLocalforestryList', []);
      commit('setSubforestryList', []);
      commit('setAreaList', []);

      if (state.selectedFo) {
        dispatch('getRegionList');
      }
    },
    selectRegion(context, payload) {
      const { state, commit, dispatch } = context;

      commit('setSelectedRegion', payload);

      commit('setSelectedForestry', null);
      commit('setSelectedLocalforestry', null);
      commit('setSelectedSubforestry', null);
      commit('setSelectedArea', null);
      commit('setSelectedSection', null);

      commit('setForestryList', []);
      commit('setLocalforestryList', []);
      commit('setSubforestryList', []);
      commit('setAreaList', []);

      if (state.selectedRegion) {
        dispatch('getForestryList');
      }
    },
    selectForestry(context, payload) {
      const { state, commit, dispatch } = context;

      commit('setSelectedForestry', payload);

      commit('setSelectedLocalforestry', null);
      commit('setSelectedSubforestry', null);
      commit('setSelectedArea', null);
      commit('setSelectedSection', null);

      commit('setLocalforestryList', []);
      commit('setSubforestryList', []);
      commit('setAreaList', []);

      if (state.selectedForestry) {
        dispatch('getLocalforestryList');
      }
    },
    selectLocalforestry(context, payload) {
      const { state, commit, dispatch } = context;

      commit('setSelectedLocalforestry', payload);

      commit('setSelectedSubforestry', null);
      commit('setSelectedArea', null);
      commit('setSelectedSection', null);

      commit('setSubforestryList', []);
      commit('setAreaList', []);

      if (state.selectedLocalforestry) {
        dispatch('getSubforestryList');
      }
    },
    selectLocalforestryGoFromLpo(context, payload) {
      const { state, commit, dispatch } = context;

      commit('setSelectedLocalforestry', payload);

      commit('setSelectedSubforestry', null);
      commit('setSelectedArea', null);
      commit('setSelectedSection', null);

      commit('setSubforestryList', []);
      commit('setAreaList', []);

      if (state.selectedLocalforestry) {
        dispatch('getSubforestryListGoFromLpo');
      }
    },
    selectSubforestry(context, payload) {
      const { state, commit, dispatch } = context;

      commit('setSelectedSubforestry', payload);

      commit('setSelectedArea', null);
      commit('setSelectedSection', null);

      commit('setAreaList', []);

      if (state.selectedSubforestry) {
        dispatch('getAreaList');
      }
    },
    selectArea(context, payload) {
      const { state, commit, dispatch } = context;

      commit('setSelectedArea', payload);
      commit('setSelectedSection', null);
    },

    getFoList(context, payload) {
      const { commit } = context;

      commit('setListLoading', 'foList');
      return fetch(GET_ALL_FO, {
        credentials: 'include'
      })
      .then(res => res.json())
      .then(res => {
        commit('setFoList', res);
      })
      .catch(err => { throw err; })
      .finally(() => commit('unsetListLoading', 'foList'));
    },

    getRegionList(context, payload) {
      const { state, commit } = context;

      const form = new FormData();
      form.append('fo_id', state.selectedFo.id);

      commit('setListLoading', 'regionList');
      return fetch(GET_ALL_REGIONS, {
        credentials: 'include',
        method: 'post',
        body: form
      })
      .then(res => res.json())
      .then(res => {
        commit('setRegionList', res);
      })
      .catch(err => { throw err; })
      .finally(() => commit('unsetListLoading', 'regionList'));
    },

    getForestryList(context, payload) {
      const { state, commit } = context;

      const form = new FormData();
      form.append('fo_id', state.selectedFo.id);
      form.append('region_id', state.selectedRegion.id);

      commit('setListLoading', 'forestryList');
      return fetch(GET_ALL_FORESTRIES, {
        credentials: 'include',
        method: 'post',
        body: form
      })
      .then(res => res.json())
      .then(res => {
        commit('setForestryList', res);
      })
      .catch(err => { throw err; })
      .finally(() => commit('unsetListLoading', 'forestryList'));
    },

    getLocalforestryList(context, payload) {
      const { state, commit } = context;

      const form = new FormData();
      form.append('fo_id', state.selectedFo.id);
      form.append('region_id', state.selectedRegion.id);
      form.append('forestry_id', state.selectedForestry.id);

      commit('setListLoading', 'localforestryList');
      return fetch(GET_ALL_LOCALFORESTRIES, {
        credentials: 'include',
        method: 'post',
        body: form
      })
      .then(res => res.json())
      .then(res => {
        commit('setLocalforestryList', res);
      })
      .catch(err => { throw err; })
      .finally(() => commit('unsetListLoading', 'localforestryList'));
    },

    getSubforestryList(context, payload) {
      const { state, commit, dispatch } = context;

      const form = new FormData();
      form.append('fo_id', state.selectedFo.id);
      form.append('region_id', state.selectedRegion.id);
      form.append('forestry_id', state.selectedForestry.id);
      form.append('localforestry_id', state.selectedLocalforestry.id);

      commit('setListLoading', 'subforestryList');
      return fetch(GET_ALL_SUBFORESTRIES, {
        credentials: 'include',
        method: 'post',
        body: form
      })
      .then(res => res.json())
      .then(res => {
        /* если в списке есть пустой элемент, нужно добавить ему надпись - нет */
        /* и переместить его в начало списка */
        if (res.length && res[res.length - 1].id === null) {
          res[res.length - 1].name = '( нет )'
          res[res.length - 1].isEmpty = true;

          res.unshift(res.pop());
        }

        /* если в списке только пустой элемент */
        /* нужно сразу его выбрать */
        if (res.length === 1 && res[0].id === null) {
          dispatch('selectSubforestry', res[0]);
        }

        commit('setSubforestryList', res);
      })
      .catch(err => { throw err; })
      .finally(() => commit('unsetListLoading', 'subforestryList'));
    },
    getSubforestryListGoFromLpo(context, payload) {
      const { state, commit, dispatch } = context;

      const form = new FormData();
      form.append('fo_id', state.selectedFo.id);
      form.append('region_id', state.selectedRegion.id);
      form.append('forestry_id', state.selectedForestry.id);
      form.append('localforestry_id', state.selectedLocalforestry.id);

      commit('setListLoading', 'subforestryList');
      return fetch(GET_ALL_SUBFORESTRIES, {
        credentials: 'include',
        method: 'post',
        body: form
      })
      .then(res => res.json())
      .then(res => {
        /* если в списке есть пустой элемент, нужно добавить ему надпись - нет */
        /* и переместить его в начало списка */
        if (res.length && res[res.length - 1].id === null) {
          res[res.length - 1].name = '( нет )'
          res[res.length - 1].isEmpty = true;

          res.unshift(res.pop());
        }

        /* если в списке только пустой элемент */
        /* нужно сразу его выбрать */
        // if (res.length === 1 && res[0].id === null) {
        //   dispatch('selectSubforestry', res[0]);
        // }

        commit('setSubforestryList', res);
      })
      .catch(err => { throw err; })
      .finally(() => commit('unsetListLoading', 'subforestryList'));
    },
    getAreaList(context, payload) {
      const { state, commit } = context;

      const form = new FormData();
      form.append('fo_id', state.selectedFo.id);
      form.append('region_id', state.selectedRegion.id);
      form.append('forestry_id', state.selectedForestry.id);
      form.append('localforestry_id', state.selectedLocalforestry.id);
      form.append('subforestry_id', state.selectedSubforestry.id);

      commit('setListLoading', 'areaList');
      return fetch(GET_ALL_AREAS, {
        credentials: 'include',
        method: 'post',
        body: form
      })
      .then(res => res.json())
      .then(res => {
        commit('setAreaList', res);
      })
      .catch(err => { throw err; })
      .finally(() => commit('unsetListLoading', 'areaList'));
    }
  }
};